export class CreateResourceRequest {
    pageName: string;
    pageContent: string;
    category: number;
    mainImageId: string;
    attachmentIds: string[];

    constructor(name: string,
        content: string,
        category: number,
        mainImageId: string,
        attachmentIds: string[]
    ) {
        this.pageName = name;
        this.pageContent = content;
        this.category = category;
        this.mainImageId = mainImageId;
        this.attachmentIds = attachmentIds;
    }
}